import React from 'react'
import LocationTag from 'library/molecules/LocationTag'
import { Text } from 'library/atoms/Typography'
import {
  StyleGuideMain,
  StyleGuideIdProps
} from 'shared/library/pages/StyleGuide'

const PROPS = {
  Description: () => (
    <>
      <Text>
        The LocationTag takes a string and an onClick function. It will render a
        tag with a pin icon and the string.
      </Text>
    </>
  ),
  examples: [
    {
      title: 'Activity LocationTag',
      code: `<LocationTag text='London, UK' onClick={() => {}}/>`,
      scope: {
        LocationTag
      }
    }
  ]
}

const LocationTagStyleGuide = (props: StyleGuideIdProps) => (
  <StyleGuideMain {...props} {...PROPS} />
)

export default LocationTagStyleGuide
